<template>
    <div class="lucky-numbers__table">
      <div class="lucky-numbers__table-title">
        CHOOSE A DRAW TO ENTER
      </div>
      <div class="lucky-numbers__table-filters">
        <div class="lucky-numbers__table-filters-filter">
          Show
          <div class="dropdown lucky-numbers__table-filters-dropdown">
            <button
                class="btn btn-secondary dropdown-toggle"
                type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
            >
              <a>{{ textDropdown }}</a>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a
                  v-for="(item, index) in perPageDropdown"
                  :key="index"
                  @click="changePerPageDropdown(index, item.value)"
                  class="dropdown-item"
                  :class="{ active: item.active }"
              >{{ item.title }}</a>
            </div>
          </div>
          entries
        </div>
        <div class="lucky-numbers__table-filters-search">
          <input
              v-model="dataSearch"
              class="form-control"
              placeholder="Search"
          />
        </div>
      </div>
      <div class="lucky-numbers__table-contents">
        <div class="lucky-numbers__table-contents-title">
          <div class="lucky-numbers__table-contents-fields">
            <div class="lucky-numbers__table-contents-fields-select">
              Select with draws to enter
            </div>
            <div class="lucky-numbers__table-contents-fields-main field-common">
              MAIN
            </div>
            <div v-if="isPlus1" class="lucky-numbers__table-contents-fields-plus-1 field-common">
              PLUS 1
            </div>
            <div v-if="isPlus2" class="lucky-numbers__table-contents-fields-plus-2 field-common">
              PLUS 2
            </div>
          </div>
        </div>
        <div
            v-for="(item, index) in paginated"
            :key="index"
            class="lucky-numbers__table-contents-item"
        >
          <div class="lucky-numbers__table-contents-item-time">
            {{ item.draw_date }}
          </div>
          <div class="lucky-numbers__table-contents-item-plus">
            <button
                @click="handleToggleYesNo(item.isMain, item.external_draw_id, 'main')"
                :class="{ active: item.isMain}"
            >{{ item.isMain ? 'YES' : 'NO' }}</button>
          </div>
          <div v-if="isPlus1" class="lucky-numbers__table-contents-item-plus">
            <button
                @click="handleToggleYesNo(item.isMain, item.external_draw_id, 'plus1')"
                :class="{ active: item.isPlus1}"
            >{{ item.isPlus1 ? 'YES' : 'NO' }}</button>
          </div>
          <div v-if="isPlus2" class="lucky-numbers__table-contents-item-plus">
            <button
                @click="handleToggleYesNo(item.isMain, item.external_draw_id, 'plus2')"
                :class="{ active: item.isPlus2}"
            >{{ item.isPlus2 ? 'YES' : 'NO' }}</button>
          </div>
        </div>
      </div>
      <Pagination
          :pageCount="totalPage"
          :numberEnd="numberEnd"
          :numberStart="numberStart"
          :total-rows="total"
          :clickHandler="handleChangePage"
          :firstLastButton="true"
          :containerClass="'pagination justify-content-end'"
          :page-class="'page-item'"
          :page-link-class="'page-link'"
          :prev-link-class="'page-item'"
          :next-link-class="'page-item'"
          :prev-class="'page-link'"
          :next-class="'page-link'"
      />
  </div>
</template>
<script>
import Pagination from '@/components/common/pagination/Paginate.vue'

export default {
  components: {
    Pagination
  },
  data () {
    return {
      total: 0,
      totalItems: 10,
      perPage: 10,
      currentPage: 1,
      numberStart: 0,
      numberEnd: 0,
      listDraws: [],
      listDataDraws: [],
      dataSearch: '',
      dataPlus: [],
      isPlus1: false,
      isPlus2: false,
      perPageDropdown: [
        {
          value: 10,
          title: '10',
          active: false
        },
        {
          value: 20,
          title: '20',
          active: false
        },
        {
          value: 50,
          title: '50',
          active: false
        },
        {
          value: 100,
          title: '100',
          active: false
        }
      ],
      textDropdown: '10',
    }
  },
  computed: {
    rows() {
      return this.total
    },
    numberPerPage() {
      return this.perPage;
    },
    additionalGames() {
      return this.$store.getters.getMarkets.additional_games
    },
    listMarkets() {
      return this.$store.getters.getMarkets.draws
    },
    indexStart() {
      return (this.currentPage - 1) * this.totalItems;
    },
    indexEnd() {
      return this.indexStart + this.totalItems;
    },
    paginated() {
      return this.handleDataPaginate()
    },
    totalPage () {
      return Math.ceil(this.rows / this.numberPerPage)
    }
  },
  watch: {
    additionalGames(val) {
      if(val.length === 1) {
        this.isPlus1 = true
        this.isPlus2 =  false
        this.dataPlus = val
      }
      if(val.length === 2) {
        this.isPlus1 = true
        this.isPlus2 =  true
        this.dataPlus = val
      }
    },
    listMarkets(val) {
      return this.listDataDraws = val;
    },
    listDataDraws(val) {
      this.listDraws = val.map(item => {
        return { ...item, draw_date: this.$filters.formatDate(item.draw_date), isMain: false, isPlus1: false, isPlus2: false }
      })
      this.total = val.length;
      if (this.total > 0) {
        this.numberStart = 1;
        if (this.total >= this.numberPerPage) {
          this.numberEnd = this.numberPerPage;
        } else {
          this.numberEnd = this.total
        }
      } else {
        this.numberStart = 0;
        this.numberEnd = 0;
      }
      this.totalItems = val.length > this.totalItems ? this.totalItems : val.length;
      this.handleToggleYesNo(true, this.listDraws[0].external_draw_id, 'main');
    },

    dataSearch(val) {
      this.searchDraw(val)
    },
    indexEnd(val) {
      this.numberEnd = this.total < val ? this.total : val;
    },
    indexStart(val) {
      this.numberStart = val === 0 ? val + 1 : val;
    }
  },
  methods: {
    handleDataPaginate() {
      const end = this.listDraws.length >= this.numberPerPage ? this.indexStart + this.numberPerPage : this.listDraws.length;
      return this.listDraws.slice(this.indexStart, end);
    },
    handlePagination(val) {
      this.total = val.length;
      if (this.total > 0) {
        this.numberStart = 1;
        if (this.total >= this.numberPerPage) {
          this.numberEnd = this.numberPerPage;
        } else {
          this.numberEnd = this.total
        }
      } else {
        this.numberStart = 0;
        this.numberEnd = 0;
      }
      this.totalItems = val.length > this.totalItems ? this.totalItems : val.length;
    },
    searchDraw(val) {
      this.currentPage = 1;
      this.listDraws = this.listMarkets.map(item => {
        return {
          ...item,
          draw_date: this.$filters.formatDate(item.draw_date),
          isMain: false,
          isPlus1: false,
          isPlus2: false
        }
      }).filter(obj => JSON.stringify(obj).includes(val));

      this.handlePagination(this.listDraws);

    },
    handleChangePage(val) {
      this.currentPage = val;
    },
    changePerPageDropdown(index, value) {
      this.perPage = value;
      this.totalItems = value;
      this.textDropdown = value;
      this.perPageDropdown.forEach((value, i) => {
        value.active = i === index ? !value.active : false
      })
    },
    handleToggleYesNo(value, id, type) {
      this.listDraws.forEach((item, _) => {
        switch (type) {
          case 'main':
            if(id === item.external_draw_id) {
              item.isMain = !item.isMain
            }
          break;
          case 'plus1':
            if(id === item.external_draw_id) {
              item.isPlus1 = !item.isPlus1
              item.slugPlus1 = this.dataPlus[0]
            }
          break;
        case 'plus2':
          if(id === item.external_draw_id) {
            item.isPlus2 = !item.isPlus2
            item.slugPlus2 = this.dataPlus[1]
          }
          break;
        }
      })
      let draws = []
      this.listDraws.filter((item) => {
        if(item.isMain) {
         draws.push(item)
        }
        if(item.isPlus1 && !item.isMain && !item.isPlus2) {
          draws.push(item)
        }
        if(item.isPlus2 && !item.isMain && !item.isPlus1) {
          draws.push(item)
        }
      })
      this.$store.dispatch('addOrUpdateDraws', draws);
    },
  }
}
</script>
